import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";

import { SplitTargetPayload } from '../entities/ShipmentOrderLegRun.entity';

import { SHIPMENT_ORDER_LEG_RUNS_QUERY_KEY } from './useQueryShipmentOrderLegRuns';

export const useMutationShipmentOrderLegRun = () => {
  const queryClient = useQueryClient();

  return {
    restoreSplitLegRun: useMutation(
      (id: number) => axios.post(`/api/v5/shipment_order_leg_runs/${id}/restore_split`),
      {
        onSuccess: () => {
          void queryClient.invalidateQueries({ queryKey: [SHIPMENT_ORDER_LEG_RUNS_QUERY_KEY] });
        }
      }
    ),
    restoreSplitLegRuns: useMutation(
      (data: { startOn: string, endOn: string }) => axios.post('/api/v5/shipment_order_leg_runs/restore_splits',
                                                     { start_on: data.startOn, end_on: data.endOn }),
      {
        onSuccess: () => {
          void queryClient.invalidateQueries({ queryKey: [SHIPMENT_ORDER_LEG_RUNS_QUERY_KEY] });
        }
      }
    ),
    splitLegRun: useMutation(
      (args: { id: number; splits: SplitTargetPayload[] }) =>
        axios.post(`/api/v5/shipment_order_leg_runs/${args.id}/split`, { splits: args.splits }),
      {
        onSuccess: () => {
          void queryClient.invalidateQueries({ queryKey: [SHIPMENT_ORDER_LEG_RUNS_QUERY_KEY] });
        },
      }
    ),
  }
};
